export default __webpack_public_path__ + "fd6c47ae798c477868e919ad64aceacc.gif";